import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["dialog"];

  open(event) {
    document.getElementById(event.currentTarget.dataset.dialogId)?.showModal();
  }

  close(event) {
    event.currentTarget.closest("dialog").close();
  }

  closeOnBackdrop(event) {
    if (event.target === event.currentTarget) event.currentTarget.close();
  }

  disconnect() {
    this.dialogTargets.forEach((dialog) => dialog.open && dialog.close());
  }
}
